export default __webpack_public_path__ + "static/media/rest5.a77b5137.jpg";